import Enum from "./EnumTemplate";


export default class SocketRouteEnum extends Enum {
    static GAME_ROOM = "ws/game_room/"
    static FRIENDSHIP_ROOM = "ws/friendship_room/"
}